export default __webpack_public_path__ + "static/media/icon-rouded.096f2e63.png";